import React,{useState, useContext} from 'react'
import Contex from '../../Context/CreateContext';
// import Contex from '../Context/CreateContext';

const   AddEdu = () => {
    const contex = useContext(Contex)
    const {CreateEdu, fetchEdu, showAlert} = contex
  const [  AddEduData, setAddEduData] = useState({ degree:"",  dept:"", uni:"",date:""  });
 

const onChange = (e)=>{
  const {name, value} = e.target
 
  setAddEduData({...  AddEduData, [name]:value})
}
const handleformSubmit =async(e)=>{
  e.preventDefault()
const  {degree, uni, dept, date  } =   AddEduData

const res = await   CreateEdu(  degree, uni, dept, date )

const json = await res.json()

  if(!res.ok){
showAlert("danger", json.msg )
}else{
  setAddEduData( { degree:"",  dept:"", uni:"",date:""  })
  await fetchEdu()
    showAlert("success", json.msg )

  }
  

 
}
  return (
<div className='container mx-auto mt-20  bg-gray-50 dark:bg-yellow-200 '>
 
  <div className="flex flex-col items-center justify-center  lg:py-0">
      <a className="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-black no-underline">
        <img className="w-8 h-8 mr-2" src="https://cdn.iconscout.com/icon/premium/png-256-thumb/note-plus-3199351-2665696.png" alt="logo" />
   Add new one Education  degree
      </a>
      </div>
     
        <div className='h-4 '>
          

</div>
      <form className=" md:p-5 pt-0 space-y-4 md:space-y-6" onSubmit={handleformSubmit} >
      <div>
              <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black"> Degree  <small className='text-red-500 text-xl' > *</small></label>
              <input type="text" name="degree" id="degree" value={ AddEduData.degree} onChange={onChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-500  w-full p-2.5  dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="degree"  />
            </div>
      <div>
              <label htmlFor="dept" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black"> Department  </label>
              <input type="text" name="dept" id="dept" value={ AddEduData.dept} onChange={onChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-500  w-full p-2.5  dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="department"  />
            </div>
      <div>
              <label htmlFor="uni" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black"> University Name <small className='text-red-500 text-xl' > *</small></label>
              <input type="text" name="uni" id="uni" value={ AddEduData.uni} onChange={onChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-500  w-full p-2.5  dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="uni"  />
            </div>
            <div>
              <label htmlFor="date" className="block mb-2 text-sm font-medium text-gray-900 dark:text-black">Date <small className='text-red-500 text-xl' > *</small></label>
              <input type="date" name="date" id="date" value={ AddEduData.date} onChange={onChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-500 w-1/2  md:w-full p-2.5  dark:bg-gray-500 dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="XYZ"  />
                         
            </div>
          
         
         <div className="flex justify-center items-center ">


            <button type="submit" className="  w-1/3 text-black bg-yellow-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Add</button>
            
         </div>
           
          
     
      </form>
           

  </div>

  )
}

export default   AddEdu